// eslint-disable-next-line import/prefer-default-export
export const categoryLabels = {
  basic: 'issuerPlatformDocuments.status.category.basic',
  'investor-only': 'issuerPlatformDocuments.status.category.investorOnly',
};
